module.exports = __webpack_public_path__ + "assets/img/header/logo.svg";